import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Spin,
  Tag,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import {
  fetchGender,
  fetchSocialRel,
} from "../../../../features/dropdown/dropdownSlice";
import { save } from "../../../../features/save/saveSlice";
import moment from "moment";

const { TextArea } = Input;

const AddDependantModal = ({
  open,
  handleCancel,
  prodd,
  folderObj,
  handleFetchData,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { fldLoading } = useSelector((state) => state.folder);
  const { genderData, loading, socialRel } = useSelector(
    (state) => state.dropdown
  );
  const { user } = useSelector((state) => state.auth);
  const { saving } = useSelector((state) => state.save);
  const [data, setData] = useState({});

  const today = new Date();
  let dd = String(today.getDate()).padStart(2, 0);
  let mm = String(today.getMonth() + 1).padStart(2, 0);
  let yyyy = today.getFullYear() - 18;

  let minDate = `${yyyy}-${mm}-${dd}`;

 
  const [formData, setFormData] = useState(prodd);

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  function onMonthChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  async function fetchGenderData() {
    await dispatch(fetchGender());
  }
  async function fetchSocialRelData() {
    await dispatch(fetchSocialRel());
  }

  const onFinish = async (data) => {
    if(!formData?.gdId){
      toast.error("Please select gender")
      return
    }
    if(!formData?.srId){
      toast.error("Please select relationship")
      return;
    }
    const res = await dispatch(
      save({
        ppId: folderObj?.ppId,
        dpId: prodd?.dpId ? prodd?.dpId : null,
        dpFirstname: formData?.dpFirstname,
        dpMiddlename: formData?.dpMiddlename,
        dpLastname: formData?.dpLastname,
        dpFullname: [
          formData.dpFirstname,
          formData.dpMiddlename,
          formData.dpLastname,
        ]
          .filter(Boolean)
          .join(" "),
        dpDob: formData?.dpDob,
        gdId: formData?.gdId,
        srId: formData?.srId,
        dpRemarks: formData?.dpRemarks,
        url: "hr/saveDependant.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData(); 
       await setFormData({})
      await handleCancel();
      await form.resetFields(); 
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  console.log("dep joy 2",formData?.dpDob)

  // const initialFormValues = {
  //   ...prodd,
  //   dpDob: prodd?.dpDob
  //     ? dayjs(prodd?.dpDob)
  //     : data?.dpDob
  //     ? dayjs(data?.dpDob)
  //     : null,
  // };

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit Dependant ${prodd?.dpFullname}`
            : "Add dependant details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
          // initialValues={initialFormValues}
        >
          <div className="grid grid-cols-2 gap-x-5">
            <Form.Item
              label="Staff Name"
              rules={[
                {
                  required: true,
                  message: "Select staff",
                },
              ]}
            >
              <Input
                readOnly={true}
                value={folderObj?.ppFullname}
                className="input"
              />
            </Form.Item>
            <Form.Item
              label="First Name"
              rules={[
                {
                  required: true,
                  message: "Enter first name",
                },
              ]}
            >
              <Input
                name="dpFirstname"
                required
                onChange={onChange}
                value={formData?.dpFirstname}
                className="input"
              />
            </Form.Item>
            <Form.Item
              label="Middle Name"
              rules={[
                {
                  required: true,
                  message: "Enter middle name",
                },
              ]}
            >
              <Input
                required
                name="dpMiddlename"
                onChange={onChange}
                value={formData?.dpMiddlename}
                className="input"
              />
            </Form.Item>
            <Form.Item
              label="Last Name"
              rules={[
                {
                  required: true,
                  message: "Enter last name",
                },
              ]}
            >
              <Input
                required
                name="dpLastname"
                onChange={onChange}
                value={formData?.dpLastname}
                className="input"
              />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: false,
                  message: "Field is required",
                },
              ]}
              label="Date of Birth"
            >
              <DatePicker
                name="dpDob"
                maxDate={dayjs(minDate)}
                className="input"
                placeholder={
                  formData?.dpDob
                    ? moment(formData.dpDob)?.format("DD-MM-YYYY")
                    : "Select Date"
                }
                value={formData?.dpDob ? dayjs(formData.dpDob) : null} 
                format={"DD-MM-YYYY"}
                onChange={(value) => {
                  onMonthChange(value, "dpDob");
                }}
              />
            </Form.Item>

            <Form.Item
              className=""
              label={<span>Gender</span>}
              rules={[
                {
                  required: true,
                  message: "Please select gender",
                },
              ]}
            >
              <Select
                name="gdId"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  genderData?.length > 0 &&
                  genderData?.map((item) => ({
                    value: item?.gdId,
                    label: item?.gdName,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "gdId");
                }}
                value={formData?.gdId}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchGenderData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              className=""
              label={<span>Social Relationship</span>}
              rules={[
                {
                  required: true,
                  message: "Please select social relationship",
                },
              ]}
            >
              <Select
                name="srId"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  socialRel?.length > 0 &&
                  socialRel?.map((item) => ({
                    value: item?.srId,
                    label: item?.srRelname,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "srId");
                }}
                value={formData?.srId}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchSocialRelData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>
          </div>

          <div className="w-full">
            <Form.Item
              label="Remarks"
              rules={[
                {
                  required: true,
                  message: "Enter remarks of this dependant",
                },
              ]}
            >
              <TextArea
                name="dpRemarks"
                required
                onChange={onChange}
                value={formData?.dpRemarks}
                rows={4}
                placeholder="Enter description"
                className="input-textarea"
              />
            </Form.Item>
          </div>
          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddDependantModal;
